import client from '@/api/client.js';
import i18n from '@/plugins/i18n.js';
import store from "@/store";
export default {
    methods: {
        async getDocumentsByJobId(jobId) {
            var meta = { clientApiMethod: 'getDocumentsByJobId', input: { jobId: jobId } }
            var response = await client().get(store.state.apiRouteRoot + "documents/GetAll/Job/" + jobId, { meta: meta })
            return response?.data;
        },
        async getDocumentsByModelId(modelId) {
            var meta = { clientApiMethod: 'getDocumentsByModelId', input: { modelId: modelId } }
            var response = await client().get(store.state.apiRouteRoot + "documents/GetAll/MachineModel/" + modelId, { meta: meta })
            return response?.data;
        },
        async addJobDocument(doc, jobId, sharebool) {
            var meta = {
                clientApiMethod: 'addJobDocument',
                input: { doc, jobId: jobId, sharebool: sharebool },
                successText: i18n.t("servicesystem.responses.created_object", { okey: i18n.t("servicesystem.common_objects.document.document") })
            }
            var response = await client().post(store.state.apiRouteRoot + "jobdocuments/" + jobId + "?toCustomer=" + sharebool, doc, {
                headers: { 'Content-Type': 'multipart/form-data', meta: meta },
                transformRequest: formData => formData,
            });
            return response?.data;
        },
        async changeDocument(changedDoc) {
            var meta = {
                clientApiMethod: 'changeDocument',
                input: { changedDoc },
                successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.document.document") })
            }
            var query =
                "?DocumentTypeCategoryId=" + changedDoc.DocumentTypeCategoryId +
                "&Name=" + changedDoc.Name +
                "&PublishToCustomer=" + changedDoc.PublishToCustomer;
            var response = await client().patch(store.state.apiRouteRoot + "documents/Change/" + changedDoc.Id + query, null, { meta: meta })
            return response?.data;
        },
        async deleteDocument(targetDoc) {
            var meta = { clientApiMethod: 'deleteDocument', input: { targetDoc } }
            var query = "?DocumentTypeCategoryId=" + targetDoc.DocumentTypeCategoryId;
            var response = await client().delete(store.state.apiRouteRoot + "documents/Delete/" + targetDoc.Id + query, { meta: meta })
            return response?.data;
        },
        getFileTypeMethodRoute(file) {
            var methodpath;
            if (file.MachineId > -1) {
                methodpath = "machine/document/";
            } else {
                methodpath = "jobdocuments/";
            }
            return methodpath;
        },




        async getResourcesByEntity(entityClass, entityId) {
            var meta = { clientApiMethod: 'getResourcesByEntity', input: { entityClass: entityClass, entityId: entityId } }
            var response = await client().get(`${store.state.apiRouteRoot}${entityClass}/${entityId}/Documents`, { meta: meta })
            return response?.data;
        },


        async uploadResourceToEntity(entityClass, entityId, documentTypeId, files, externalContent) {
            //console.log('uploadResourceToEntity', entityClass, entityId, documentTypeId, files, externalContent);
            let formData = new FormData();
            var filenames = [];
            if (files) {
                for (var filekey in files) {
                    if (Object.prototype.hasOwnProperty.call(files, filekey)) {
                        const file = files[filekey];
                        formData.append("Files", file, file.name);
                        filenames.push(file.name);
                    }
                }
            }
            if (externalContent && externalContent.length) {
                //formData.append("ExternalContent", JSON.stringify(externalContent));
                for (let index = 0; index < externalContent.length; index++) {
                    const element = externalContent[index];
                    //console.log('element', element);
                    formData.append(`ExternalContent[${index}].Name`, element.Name);
                    formData.append(`ExternalContent[${index}].Content`, element.Content);
                    formData.append(`ExternalContent[${index}].PublishToCustomer`, element.PublishToCustomer);
                }
            }
            formData.append("DocumentTypeId", documentTypeId);

            var meta = {
                clientApiMethod: 'uploadResourcesToEntity',
                input: { entityClass: entityClass, entityId: entityId, documentTypeId: documentTypeId, filenames: filenames, externalContent: externalContent },
                successText: i18n.t("servicesystem.responses.upload_success"),
            }
            var response = await client().post(`${store.state.apiRouteRoot}${entityClass}/${entityId}/Documents`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
                transformRequest: formData => formData,
                meta: meta
            });
            return response?.data;
        },


        async togglePublishToCustomer(entityClass, documentTypeId, documentId) {
            var meta = {
                clientApiMethod: 'togglePublishToCustomer',
                input: { entityClass: entityClass, documentTypeId: documentTypeId, documentId: documentId }
            }
            var response = await client().patch(`${store.state.apiRouteRoot}${entityClass}/Documents/${documentId}/${documentTypeId}/TogglePublishToCustomer`, null, { meta: meta })
            return response?.data;
        },

        async deleteResourcesFromEntity(entityClass, entityId, documentTypeId, documentId) {
            var meta = {
                clientApiMethod: 'getResourcesByEntity',
                input: { entityClass: entityClass, entityId: entityId, documentTypeId: documentTypeId, documentId: documentId },
                successText: i18n.t("servicesystem.responses.deleted_success"),
            }
            var response = await client().delete(`${store.state.apiRouteRoot}${entityClass}/${entityId}/Documents/${documentId}/${documentTypeId}`, { meta: meta })
            return response?.data;
        },
    }
}